import React from "react";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import { FormLabel, GridLegacy } from "@mui/material";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormFieldTwoColumns from "../../../../components/Forms/Layouts/FormFieldTwoColumns";
import { useController, useFormContext } from "react-hook-form";
import TranslatableEditor from "../../../../components/TranslatableEditor/TranslatableEditor";
import FormCustomizableTextTC from "../../../../components/Forms/FormCustomizableTextTC";

export default function CustomAgeVerifyNotification() {
  const { vestigingId } = useFormContext();
  const {
    field: { value: extra_settings_id },
  } = useController({ name: "extra_settings__id" });

  let endpointParamsExtraSettings = { model_name: "extra_settings", id: extra_settings_id };

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy item lg={12} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <Card>
                <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                  <FormFieldTwoColumns
                    label={
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Custom age verify notification message"}
                          tKey={"vestigingen.custom_age_verify_notification_message"}
                        />
                      </FormLabel>
                    }
                  >
                    <TranslatableEditor
                      contentName={"custom_age_verify_notification_message"}
                      endpointParams={endpointParamsExtraSettings}
                    />
                  </FormFieldTwoColumns>

                  <FormCustomizableTextTC
                    model={"vestiging"}
                    modelId={vestigingId}
                    tDefault={"Custom age verify notification checkbox line"}
                    tKey={"vestigingen.custom_age_verify_notification_checkbox_line"}
                    translatableText={"custom_age_verify_notification_checkbox_line"}
                  />
                </CardBody>
              </Card>
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}
